module.exports = __webpack_public_path__ + "img/Lasagna Meal-Chicken Pesto.1385e881.jpg";